import { FoodSupplement } from '@repo/types/src/food-supplement';
import { FoodSupplementCard } from './FoodSupplementCard';

type FoodSupplementListProps = {
  items: FoodSupplement[];
  refetch: () => void;
};

export const FoodSupplementList = ({
  items,
  refetch,
}: FoodSupplementListProps) => {
  return (
    <div className="flex flex-col gap-4 h-full overflow-auto pb-12">
      <div className="flex flex-wrap gap-4">
        {items.map((item) => (
          <FoodSupplementCard key={item.id} item={item} refetch={refetch} />
        ))}
      </div>
    </div>
  );
};
